import type { PropsWithChildren } from "react";

import QuestionMarkIcon from "$/lib/icons/QuestionMarkIcon";
import { cn } from "$/lib/utils/functions/misc.functions";

import Tooltip from "../../organisms/Tooltip/Tooltip";

type Props = {
  info: string | JSX.Element;
  className?: string;
  contentClassName?: string;
  color?: "default" | "warning";
  // Force l'ouverture du tooltip depuis l'extérieur (ex. survol/tap d'une
  // barre de graphique associée à cette info), en plus du hover/tap natif.
  forceOpen?: boolean;
};

export const Info = ({
  info,
  className,
  contentClassName,
  children,
  color = "default",
  forceOpen,
}: PropsWithChildren<Props>) => {
  return (
    <Tooltip
      content={info}
      delayDuration={100}
      contentClassName={contentClassName}
      forceOpen={forceOpen}
    >
      <div
        className={cn(
          "flex size-[30px] shrink-0 items-center justify-center rounded-full bg-info text-textColor hover:bg-primary-100/70 hover:text-primary",
          className,
        )}
      >
        {children ?? (
          <QuestionMarkIcon
            className={cn("size-3", { "text-warning": color === "warning" })}
          />
        )}
      </div>
    </Tooltip>
  );
};
